module.exports = "/images/chms.svg?c957f2dc8ecae6fb2e1caa44adc12796";